var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66732 5.33334V12C4.66732 12.7364 5.26427 13.3333 6.00065 13.3333H10.0007C10.737 13.3333 11.334 12.7364 11.334 12V5.33334H12.6673V12C12.6673 13.4728 11.4734 14.6667 10.0007 14.6667H6.00065C4.52789 14.6667 3.33398 13.4728 3.33398 12V5.33334H4.66732Z",
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.33334C6.29848 7.33334 6 7.63182 6 8.00001V10.6667C6 11.0349 6.29848 11.3333 6.66667 11.3333C7.03486 11.3333 7.33333 11.0349 7.33333 10.6667V8.00001C7.33333 7.63182 7.03486 7.33334 6.66667 7.33334Z",
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 7.33334C8.96514 7.33334 8.66667 7.63182 8.66667 8.00001V10.6667C8.66667 11.0349 8.96514 11.3333 9.33333 11.3333C9.70152 11.3333 10 11.0349 10 10.6667V8.00001C10 7.63182 9.70152 7.33334 9.33333 7.33334Z",
    fill: "#059669"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33268 4.00001V3.33334C5.33268 2.22877 6.22811 1.33334 7.33268 1.33334H8.66602C9.77059 1.33334 10.666 2.22877 10.666 3.33334V4.00001H12.666C13.0342 4.00001 13.3327 4.29849 13.3327 4.66668C13.3327 5.03487 13.0342 5.33334 12.666 5.33334H3.33268C2.96449 5.33334 2.66602 5.03487 2.66602 4.66668C2.66602 4.29849 2.96449 4.00001 3.33268 4.00001H5.33268ZM6.66602 3.33334C6.66602 2.96515 6.96449 2.66668 7.33268 2.66668H8.66602C9.0342 2.66668 9.33268 2.96515 9.33268 3.33334V4.00001H6.66602V3.33334Z",
    fill: "#059669"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1b97cedb328293db234c9a4f7ffdf243.svg";
export { ForwardRef as ReactComponent };